import {useCallback, useState} from "react";

export default function useLoading(initialState: boolean = false): [boolean, () => void, () => void] {
    const [loading, setLoading] = useState<boolean>(initialState);
    const startLoading = () => setLoading(true);
    const stopLoading = () => setLoading(false);
    return [loading, startLoading, stopLoading];
}